import React from 'react';
import Header from "../../Header/Header";
import { headerObjTen } from "../../Header/HeaderData";

function Testimonials() {
  return (
    <>
      <Header {...headerObjTen} />
      <div className="board-category5">
        <div className="category-title">Coming Soon</div>
      </div>
    </>
  );
}

export default Testimonials;